import React, { useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { Calendar as CalendarIcon, X } from "lucide-react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const toISO = (date) => format(date, "yyyy-MM-dd");

export const DateField = ({ value, onChange, placeholder = "Pick a date", testId = "date-field", clearable = true, fromYear = 2020, toYear = 2035 }) => {
  const [open, setOpen] = useState(false);
  const parsed = value ? parseISO(value) : null;
  const selected = parsed && isValid(parsed) ? parsed : undefined;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`${testId}-trigger`}
          className="w-full mt-1.5 flex items-center justify-between gap-2 rounded-2xl border border-slate-200 bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04),0_10px_30px_-24px_rgba(15,23,42,0.22)] px-3 py-2.5 text-left text-sm text-slate-900 shadow-sm transition-colors hover:border-sky-300 focus:outline-none focus:ring-2 focus:ring-sky-200">
          <span className={selected ? "font-medium" : "text-slate-400"}>
            {selected ? format(selected, "dd MMM yyyy") : placeholder}
          </span>
          <span className="flex items-center gap-1.5">
            {clearable && selected && (
              <X className="w-3.5 h-3.5 text-slate-400 hover:text-rose-500" data-testid={`${testId}-clear`}
                 onClick={(e) => { e.stopPropagation(); onChange(""); }} />
            )}
            <CalendarIcon className="w-4 h-4 text-sky-600" />
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0 bg-white border-slate-200 shadow-xl" data-testid={`${testId}-popover`}>
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected}
          onSelect={(date) => { onChange(date ? toISO(date) : ""); setOpen(false); }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};

export default DateField;
